/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2024-09-03 10:25:34
 * @FilePath: \crane-safety-manager\src\slices\project\thunk.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIClient } from '../../helpers/api_helper';
import * as ToastHelper from '../../helpers/toast_helper';

const prefix = 'project';
const tname = '项目';

export const getAll = createAsyncThunk(`${prefix}/get-all`, async function () {
    const { data } = await APIClient.get('/projects');
    return data;
});

export const getProject = createAsyncThunk(`${prefix}/get-project`, async function (id) {
    const { data } = await APIClient.get(`/companies/${id}/projects`);
    return data;
});

export const create = createAsyncThunk(`${prefix}/create`, async function (payload) {
    try {
        const response = await APIClient.post('/projects', payload);
        ToastHelper.createSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.createFailed(tname);
        throw error;
    }
});

export const update = createAsyncThunk(`${prefix}/update`, async function (payload) {
    try {
        const response = await APIClient.put(`/projects/${payload.id}`, payload);
        ToastHelper.updateSucceeded(tname);
        return response.data;
    } catch (error) {
        ToastHelper.updateFailed(tname);
        throw error;
    }
});

export const remove = createAsyncThunk(`${prefix}/remove`, async function (id) {
    try {
        await APIClient.delete(`/projects/${id}`);
        ToastHelper.removeSucceeded(tname);
        return id;
    } catch (error) {
        var tnames = tname;
        if (error.response.data.includes('foreign key constraint')) {
            tnames = '项目下存在关联工地，删除';
        }
        ToastHelper.removeFailed(tnames);
        throw error;
    }
});
